import React from "react";
import CSSModules from "react-css-modules";
import styles from "../cardMakeAPayment.scss";
import PropTypes from "prop-types";
import classNames from "classnames";
import NumberFormatter from "../../utils/numberFormatter";

@CSSModules(styles, { allowMultiple: true })
class AmountOptions extends React.Component {
  static propTypes = {
    selected: PropTypes.string,
    onChange: PropTypes.func,
    otherAmountInput: PropTypes.element,
    statementPaymentAmount: PropTypes.number,
    currentBalanceAmount: PropTypes.number,
    statementEndingBalance: PropTypes.number,
    errors: PropTypes.array,
    allDisabled: PropTypes.bool,
  };

  handleOnClick = event => {
    const { value } = event.target;
    this.props.onChange(value);
  };

  render() {
    const options = [
      {
        value: "STATEMENT_BLANACE",
        text: `Statement Balance`,
        element: NumberFormatter.getCurrencyFormattedNumber(
          this.props.statementEndingBalance
        ),
        amount: this.props.statementEndingBalance
      },
      {
        value: "CURRENT_BLANACE",
        text: `Current Balance`,
        element: NumberFormatter.getCurrencyFormattedNumber(
          this.props.currentBalanceAmount
        ),
        amount: this.props.currentBalanceAmount
      },
      {
        value: "MINIMUM_PAYMENT",
        text: `Minimum Payment`,
        element: NumberFormatter.getCurrencyFormattedNumber(
          this.props.statementPaymentAmount
        ),
        amount: this.props.statementPaymentAmount
      },
      {
        value: "OTHER",
        text: `Other Amount`,
        element: this.props.otherAmountInput
      }
    ];
    return (
      <ul styleName="paymentMethods" data-at={`amount-options-list`}>
        {options.map(option => {
          const selected = option.value === this.props.selected;
          let disabled = this.props.allDisabled;
          if (option.amount !== undefined && option.amount < 2) {
            disabled = true;
          }
          return (
            <li
              styleName={classNames("amountOption", { disabled })}
              key={option.value}
              data-at={`amount-options-${option.value}-item`}
            >
              <label
                styleName={classNames(option.className, { selected, disabled })}
                data-at={`amount-options-${option.value}-label`}
              >
                <input
                  type="radio"
                  name="amountOption"
                  value={option.value}
                  checked={selected}
                  onChange={this.handleOnClick}
                  disabled={disabled}
                  data-at={`amount-options-${option.value}-input`}
                />
                <span
                  styleName="text"
                  data-at={`amount-options-${option.value}-text`}
                >
                  {option.text}
                </span>
                <span data-at={`amount-options-${option.value}-value-text`}>
                  {option.element}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default AmountOptions;



// WEBPACK FOOTER //
// ./src/card/makeAPayment/AmountOptions.js